import { createEndpoint } from "../createEndpoint";
import { HttpClient } from "../httpClient";
import { GeoRegionsSchema } from "../schemas/geo-regions";

export function createGeoRegionsApi(http: HttpClient, baseUrl: string) {
    return {
        getGeoRegions: createEndpoint(http, "GET", "/geo-regions", {
            base: baseUrl,
            responseSchema: GeoRegionsSchema,
        }),
    };
}
